var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { getResponsiveProp, rem, responsive } from '../../styles';
import { childrenToElementArray } from '../helpers';
import { AvatarCounter } from './avatarCounter';
function avatarStackStyle() {
    return css `
    white-space: nowrap;

    & > div {
      vertical-align: top;

      &:not([hidden]) {
        display: inline-block;
      }
    }
  `;
}
function responsiveAvatarStackSizeStyle(props) {
    const { theme } = props;
    const { avatar, media } = theme.sanity;
    return responsive(media, getResponsiveProp(props.size), (size) => {
        const avatarSize = avatar.sizes[size];
        if (!avatarSize)
            return {};
        return {
            '& > div + div': {
                marginLeft: rem(avatarSize.distance),
            },
        };
    });
}
const Root = styled.div(responsiveAvatarStackSizeStyle, avatarStackStyle);
export const AvatarStack = forwardRef((props, ref) => {
    const { children: childrenProp, maxLength: maxLengthProp = 4, size = 0, tone } = props, restProps = __rest(props, ["children", "maxLength", "size", "tone"]);
    const maxLength = Math.max(maxLengthProp, 0);
    const children = childrenToElementArray(childrenProp).filter((child) => typeof child !== 'string');
    const len = children.length;
    const visibleCount = maxLength - 1;
    const extraCount = len - visibleCount;
    const visibleChildren = extraCount > 1 ? children.slice(extraCount, len) : children;
    return (React.createElement(Root, Object.assign({ "data-ui": "AvatarStack" }, restProps, { ref: ref, size: size }),
        len === 0 && (React.createElement("div", null,
            React.createElement(AvatarCounter, { count: len, tone: tone }))),
        len !== 0 && extraCount > 1 && (React.createElement("div", null,
            React.createElement(AvatarCounter, { count: extraCount, size: size, tone: tone }))),
        visibleChildren.map((child, childIndex) => (React.createElement("div", { key: String(childIndex) }, cloneElement(child, { size, tone }))))));
});
AvatarStack.displayName = 'AvatarStack';
//# sourceMappingURL=avatarStack.js.map